type UnitValueProps = {
  children?: React.ReactNode;
  unit?: React.ReactNode;
};

export const UnitValue = ({ children, unit }: UnitValueProps) => {
  return (
    <p className="p-normal">
      <span className="p-normal">{children}</span>{' '}
      <span className="p-caption">{unit}</span>
    </p>
  );
};
